import React from "react";
const Claim = React.lazy(() =>
  import(/* webpackChunkName: "Claim" */ "./AllCharges/Claim/Claim")
);
const InstitutionalClaim = React.lazy(() =>
  import(
    /* webpackChunkName: "Claim" */ "./AllCharges/Claim/InstitutionalClaim"
  )
);
const ChargesSearch = React.lazy(() =>
  import(
    /* webpackChunkName: "ChargesSearch" */ "./ChargesSearch/ChargesSearch"
  )
);
const ChargesSearchNewDesign = React.lazy(() =>
  import(
    /* webpackChunkName: "ChargesSearchNewDesign" */ "./ChargesSearchNewDesign/ChargesSearchNewDesign"
  )
);

export const ChargesTabsComponent = {
  ChargesSearch,
  ChargesSearchNewDesign,
  Claim,
  InstitutionalClaim,
};
const ChargesTabsObj = () => {
  return [
    {
      title: "Search",
      Component: "ChargesSearchNewDesign",
      icon: "",
      right: true,
      eventKey: 68, // press d from keyboard
    },

    {
      title: "Claim",
      Component: "Claim",
      icon: "",
      right: true,
      eventKey: 68, // press d from keyboard
    },
    {
      title: "Institutional Visit",
      Component: "InstitutionalClaim",
      icon: "",
      right: true,
      eventKey: 68, // press d from keyboard
    },
  ];
};

export default ChargesTabsObj;

